var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-fluid"},[_c('div',{staticClass:"p-col-12 p-lg-12"},[_c('div',{staticClass:"card card-w-title"},[_c('div',{staticClass:"group-permission-title"},[_vm._v(_vm._s(_vm.title))]),_c('formEdit',{key:_vm.componentKey,attrs:{"mode":_vm.mode,"model":_vm.models},on:{"back":_vm.backToList}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }